import type { KpiCardSpec } from './card-spec';

/**
 * The no-campaign Coupons redeemed scalar, closing the headline row on Overview,
 * Engagement, Retention and Demographic. One object in every catalog, so no two
 * pages can report different figures for the same KPI.
 */
export const COUPONS_REDEEMED_SCALAR_CARD: KpiCardSpec = {
    title: 'Coupons redeemed',
    source: 'coupon-redeemed',
    form: 'number',
    metric: 'couponsRedeemed',
    size: 'sm',
    description:
        'Coupons redeemed in the selected period across the promotions belonging to no campaign, following the page Period and Region filters, with a period-over-period delta. The design mock asks for a redemption rate instead, which needs one chosen promotion carrying a catalog cap, and these pages offer no way to pick one. RPP and Road to Rewards report their own figures, never numbers to add to this one.',
};
